export default {
  'MICRO_ENTERPRISE': 'less than 10 People',
  'SMALL_ENTERPRISE': '10 to 49 People',
  'MEDIUM_ENTERPRISE': '50 to 250 People',
  'LARGE_ENTERPRISE': 'more than 250 People'
}
